import React from 'react';
import { Link } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import BtnFilled from '../../components/BtnFilled';
import BtnOutlined from '../../components/BtnOutlined';
import { formatDateTime, formatValue, getDeviceRowStatus } from './utils';

const SerialOtaLink = (serialNumber) => {
  if (!serialNumber) return '-';

  const params = new URLSearchParams({ serial_number: serialNumber, channel: 'test' });

  return (
    <Link to={`/ota-events?${params}`} title="Журнал OTA-событий" className="text-orange-500 hover:underline">
      {serialNumber}
    </Link>
  );
};

const STATUS_BADGE = {
  done: {
    label: 'Обновился',
    className: 'bg-green-50 text-green-700',
    icon: <CheckCircleIcon className="!w-4 !h-4" />,
  },
  pending: {
    label: 'Отстаёт',
    className: 'bg-orange-200 text-orange-800',
    icon: <WarningAmberIcon className="!w-4 !h-4" />,
  },
  excluded: {
    label: 'Выведен',
    className: 'bg-gray-100 text-gray-500',
    icon: <RemoveCircleOutlineIcon className="!w-4 !h-4" />,
  },
};

export const getTestDevicesColumns = () => [
  { key: 'serial_number', title: 'Серийный номер', render: formatValue },
  { key: 'current_version', title: 'Текущая версия', render: formatValue },
  { key: 'reported_version', title: 'Отчитанная версия', render: formatValue },
  { key: 'last_seen', title: 'Последний выход на связь', render: formatDateTime },
];

export const getFirmwareVersionColumns = ({ actionTitle, onAction, isDisabled, actionLoading }) => [
  { key: 'version', title: 'Версия', render: formatValue },
  { key: 'models', title: 'Модели', render: (value) => (value?.length ? value.join(', ') : '-') },
  { key: 'modified_at', title: 'Дата', render: formatDateTime },
  { key: 'files', title: 'Файлов', render: (value) => value?.length ?? 0 },
  {
    key: 'actions',
    title: '',
    render: (row) => <BtnFilled title={actionTitle} disabled={actionLoading || isDisabled?.(row)} btnCb={() => onAction(row.version)} />,
  },
];

export const getCampaignDevicesColumns = ({ onExclude, actionLoading, excludingId }) => [
  { key: 'serial_number', title: 'Серийный номер', render: SerialOtaLink },
  { key: 'version_before', title: 'Версия до обкатки', render: formatValue },
  { key: 'reported_version', title: 'Текущая версия', render: formatValue },
  { key: 'last_seen', title: 'Выходил на связь', render: formatDateTime },
  {
    key: 'actions',
    title: 'Статус',
    render: (row) => {
      const badge = STATUS_BADGE[getDeviceRowStatus(row)];
      if (!badge) return '-';

      return (
        <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-sm font-medium ${badge.className}`}>
          {badge.icon}
          {badge.label}
        </span>
      );
    },
  },
  {
    key: 'actions',
    title: '',
    render: (row) =>
      getDeviceRowStatus(row) === 'pending' ? (
        <BtnOutlined
          title="Вывести из обкатки"
          className="min-w-[180px]"
          disabled={excludingId === row.device_id || actionLoading}
          btnCb={() => onExclude(row)}
        />
      ) : null,
  },
];
